module.exports = "/static/assets/e2caa77932e7f773df1adfaa73a472a2.svg";